import React from 'react';
export function TransitionSection() {
  return <section className="bg-black py-16 md:py-24 border-y border-nero-border/20" data-id="element-287">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-288">
        <p className="text-white text-lg md:text-xl mb-6 leading-relaxed" data-id="element-289">
          You don't need more motivation. You don't need another free YouTube
          video. You don't need to post more on Instagram.
        </p>
        <h2 className="text-soft-gold text-2xl md:text-4xl font-bold mb-6 font-playfair" data-id="element-290">
          You need a complete business system — built specifically for PTs like
          you.
        </h2>
        <p className="text-[#CCCCCC] text-base md:text-lg" data-id="element-291">
          That's exactly what we built.
        </p>
      </div>
    </section>;
}